import { t } from "@lingui/macro";
import * as React from "react";
import { ClipPath, Defs, Path, Rect, G } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ShuffleboardIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    color="currentColor"
    title={t`Shuffleboard`}
    {...props}
  >
    <G clip-path="url(#clip0_7655_42676)" fill="none">
      <Path
        d="M8 2.75C10.1047 2.75 11.9731 3.23148 13.2891 3.97168C14.6285 4.72513 15.25 5.64866 15.25 6.5C15.25 7.35134 14.6285 8.27487 13.2891 9.02832C11.9731 9.76852 10.1047 10.25 8 10.25C5.89532 10.25 4.02689 9.76852 2.71094 9.02832C1.37147 8.27487 0.75 7.35134 0.75 6.5C0.75 5.64866 1.37147 4.72513 2.71094 3.97168C4.02689 3.23148 5.89532 2.75 8 2.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <Path
        d="M0.748047 9.99902L0.746094 7.95898C1.08938 8.17859 1.49616 8.42303 1.95996 8.66504C3.46041 9.44795 5.58221 10.2499 7.99609 10.25C10.4101 10.25 12.5327 9.44779 14.0332 8.66504C14.4966 8.4233 14.903 8.17935 15.2461 7.95996L15.2451 9.99902V10C15.2451 11.1131 14.6178 11.921 13.3447 12.4941C12.039 13.0819 10.1627 13.3564 7.99609 13.3564C5.82968 13.3564 3.95408 13.0818 2.64844 12.4941C1.37509 11.921 0.748047 11.1132 0.748047 10V9.99902Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <Path
        d="M11 6.5C11 7.32843 9.65685 8 8 8C6.34315 8 5 7.32843 5 6.5C5 5.67157 6.34315 5 8 5C9.65685 5 11 5.67157 11 6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_7655_42676">
        <Rect width="16" height="16" fill="none" />
      </ClipPath>
    </Defs>
  </Icon>
);
